export default __webpack_public_path__ + "static/media/2728 spice rack side.e9a4ae8d.png";